import { PlayerKey } from "../assets/script/constants";

/**
 * @type {{add_user: string}}
 */
export const TimerActions = {
  startTimer: "start_timer",
  stopTimer: "stop_timer",
  resetTimer: "reset_timer",
};

/**
 * @type {{add_user: string}}
 */
export const frameworkActions = {
  resetBase: "reset_base",
  resetAll: "reset_all_bases",
  setBase: "set_base",
  setLeader: "set_leader",
  resetLeader: "reset_leader",
};

/**
 * @name resetBaseReducer
 * @param {SwucState} state
 * @param {"top" | "bottom"} payload
 * @return {SwucState}
 */
function resetBaseReducer(state, payload) {
  if (payload !== PlayerKey.top && payload !== PlayerKey.bottom) {
    console.error("Invalid payload", payload);
    return state;
  }
  if (state[payload] === undefined) {
    console.error("Invalid state", state);
    return state;
  }
  const newState = { ...state };
  newState[payload].base = undefined;
  return newState;
}

/**
 * @name resetAllReducer
 * @param {SwucState} state
 * @return {SwucState}
 */
function resetAllReducer(state) {
  const newState = { ...state };
  newState.top.base = undefined;
  newState.top.leader = undefined;
  newState.top.remainingHp = 0;
  newState.bottom.base = undefined;
  newState.bottom.leader = undefined;
  newState.bottom.remainingHp = 0;
  newState.currentGame = undefined;
  return newState;
}

/**
 *  @name setBaseReducer
 * @param {SwucState} state
 * @param {{base, string}} payload
 * @return {SwucState}
 */
function setBaseReducer(state, { base, player }) {
  if (player !== PlayerKey.top && player !== PlayerKey.bottom) {
    console.error("Invalid payload", { base, player });
    return state;
  }
  if (state[player] === undefined) {
    console.error("Invalid state", state);
    return state;
  }
  const newState = { ...state };
  newState[player].base = base;
  newState[player].remainingHp = base.hp;
  newState.ui.showBaseModal.show = false;
  newState.ui.showBaseModal.player = "none";
  return newState;
}

/**
 * @name setLeaderReducer
 * @param {SwucState} state
 * @param {{leader, string}} payload
 * @return {SwucState}
 */

function setLeaderReducer(state, { leader, player }) {
  console["log"]("🐵: ", leader, player);
  if (player !== "top" && player !== "bottom") {
    console.error("Invalid payload", { leader, player });
    return state;
  }
  if (state[player] === undefined) {
    console.error("Invalid state", state);
    return state;
  }
  const newState = { ...state };
  newState[player].leader = leader;
  return newState;
}

function resetLeaderReducer(state, player) {
  if (player !== "top" && player !== "bottom") {
    console.error("Invalid payload", player);
    return state;
  }
  if (state[player] === undefined) {
    console.error("Invalid state", state);
    return state;
  }
  const newState = { ...state };
  newState[player].leader = undefined;
  return newState;
}
/**
 * @type {{string: function(SwucState, string=): SwucState}}
 */
export const FrameworkReducers = {
  [frameworkActions.resetBase]: resetBaseReducer,
  [frameworkActions.setBase]: setBaseReducer,
  [frameworkActions.setLeader]: setLeaderReducer,
  [frameworkActions.resetLeader]: resetLeaderReducer,
  [frameworkActions.resetAll]: resetAllReducer,
};
